import React, { useRef } from "react";

const HealthBloodUpdateForm = ({ onSubmit, onCancel, item }) => {
	const commentRef = useRef(item.comment);
	setTimeout(() => {
		if (commentRef && commentRef.current) {
			commentRef.current.value = item.comment;
		}
	}, 0);
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
				onSubmit({
					comment: commentRef.current.value
				});
			}}
		>
			<h3 className="text-success">Additional Information</h3>
			<div className="form-group m-t-20 m-b-20">
				<label htmlFor="comment-id">Comments</label>
				<textarea
					name="comment-id"
					id="comment-id"
					ref={commentRef}
					className="form-control form-control-textarea"
					rows="6"
					placeholder="enter comments"
				></textarea>
			</div>

			<div className="form-group text-center m-t-20">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
				>
					Update Result
					<i className="material-icons">keyboard_arrow_down</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
				>
					Cancel <i className="material-icons text-danger">close</i>
				</button>
			</div>
		</form>
	);
};
export default HealthBloodUpdateForm;
